export enum JobStatus {
  Success = 1,
  Failure = 2,
  Execution = 4,
  AwaitingReexecution = 8,
}
